import React, { useEffect } from 'react'
import { useLocation } from 'react-router-dom'
import { Auth } from '@aws-amplify/auth'
import Cookies from 'universal-cookie'
import { useAuthConfig, useSession } from '@emerald-works/react-auth'
import { useAlert } from '../../hooks'
import { NotAuthenticatedAlert } from './alert'
import NotAuthorized from './not-authorized'
import { useTenant } from '@emerald-works-nova/auth'

const Authenticate = () => {
  const location = useLocation()
  const tenant = useTenant()
  const authConfig = useAuthConfig()
  const { enqueueAlert } = useAlert()
  const cookies = new Cookies()
  const cookieKey = authConfig.afterAuthLocationCookieName
  const targetURI = `${location.pathname}${location.search}`
  cookies.set(cookieKey, targetURI, { path: '/' })
  const isThereACustomProvider = tenant.loginProviders.find(({ providerType }) => providerType === 'SAML')

  useEffect(() => {
    Auth.currentAuthenticatedUser()
      .catch(() => {
        if (tenant?.tenantKey === 'www') {
          enqueueAlert(<NotAuthenticatedAlert />)
        }
        authConfig.onAuthNeededRedirection({
          Auth,
          federatedSignInParams: { customState: cookieKey },
          location
        })
      })
  }, [authConfig, location, cookieKey, enqueueAlert, tenant, isThereACustomProvider])

  return null
}

const PrivateRoute = ({
  element,
  allowedUserGroups,
  shouldShowStubbedPage = false,
  shouldCheckAuthentication = true,
  ...rest
}) => {
  const { isAuthenticated, session } = useSession()
  const authConfig = useAuthConfig()
  const userGroups = session?.accessToken?.payload?.['cognito:groups']?.join(',') || 'defaultUserGroup'
  const userHasApplicationAccess = userGroups.match(allowedUserGroups || authConfig.allowedUserGroups)?.length > 0

  // return the Authenticate component if not authenticated
  if (!isAuthenticated) {
    return <Authenticate />
  }

  // return user not authorized component if user has no application access
  if (!userHasApplicationAccess) {
    return <NotAuthorized />
  }

  // return page
  return element
}

export default PrivateRoute
